import {
  processUnitSetLabelAction,
  processUnitSetValueAction
} from '@r/reducers/utils';
import { inches, quantity } from 'decl/general/units';
import { AllActions } from '@r/storeUtils';
import { UnitsInputValue } from '@npmrost/storybook/stories/Vesta/Inputs/UnitsInput';

type upper =
  redux._IStore['calculationMode']['projects']['currentProject']['settings']['dimensions']['cabinets']['upper'];

const upperDefault: upper = {
  height: {
    value: 36 as inches,
    label: '36' as UnitsInputValue
  },
  depth: {
    value: 11.75 as inches,
    label: '11.75' as UnitsInputValue
  },
  shelvesQty: 2 as quantity
};

export const upper = (
  state = upperDefault,
  action: AllActions
): typeof state => {
  switch( action.type ) {
    case 'SET_CALCULATION_MODE_CURRENT_PROJECT_UPPER_CABINET_HEIGHT_LABEL': {
      return {
        ...state,
        height: processUnitSetLabelAction( state.height, action )
      };
    }
    case 'SET_CALCULATION_MODE_CURRENT_PROJECT_UPPER_CABINET_HEIGHT_VALUE': {
      return {
        ...state,
        height: processUnitSetValueAction( state.height, action )
      };
    }
    case 'SET_CALCULATION_MODE_CURRENT_PROJECT_UPPER_CABINET_DEPTH_LABEL': {
      return {
        ...state,
        depth: processUnitSetLabelAction( state.depth, action )
      };
    }
    case 'SET_CALCULATION_MODE_CURRENT_PROJECT_UPPER_CABINET_DEPTH_VALUE': {
      return {
        ...state,
        depth: processUnitSetValueAction( state.depth, action )
      };
    }
    case 'SET_CALCULATION_MODE_CURRENT_PROJECT_UPPER_CABINET_SHELVES_QTY': {
      return {
        ...state,
        shelvesQty: action.value
      };
    }
    default:
      return state;
  }
};
